import React, { useRef, useState, Fragment } from 'react'
import { Grid, Typography, Switch, FormControlLabel, Button, Paper } from "@material-ui/core"
import "./app.css";
import { FormGenerator } from 'formik-generator-materialui'
import ReactJson from 'react-json-view'
import fieldsArray from './getFields'
import getDefaultValues from './getDefaultValues';
import FormDialogueExample from './FormDialogueExample';
import GetFieldsExample from './GetFieldsExample';

export function Rows({ fields, readOnly, initialValues, validationSchema }) {

  const formRef = useRef(null);

  let [result, setResult] = useState(null);

  return <div>
    <FormGenerator
      // onError={(error) => console.log("error", error)}
      onSubmitWithError={(error) => console.log("error", error)}
      readOnly={readOnly}
      formRef={formRef}
      initialValues={initialValues}
      onSubmit={(values) => {
        setResult(values)
      }}
      fields={fields}
      validationSchema={validationSchema}
    />
    <Button style={{ marginTop: 20 }} variant={"outlined"} onClick={() => {
      formRef.current.submitForm();
    }}>Validate</Button>
    {result && <div style={{ marginTop: 20 }} >
      <ReactJson name={false} displayDataTypes={false} displayObjectSize={false} theme="monokai" src={result} />
    </div>}
  </div>
}

export default function App() {

  const [readOnly, setReadOnly] = useState(false);
  const [displayAllProps, setDisplayAllProps] = useState(true);
  let [initialValues, setDefaultValues] = useState(getDefaultValues(fieldsArray, true));

  return (
    <div className="root">
      <div className="center">
        <Typography variant="h4" className="title" gutterBottom component="span">
          formik-generator-materialui
        </Typography>
      </div>
      <div>
        <FormControlLabel
          control={
            <Switch
              checked={!!readOnly} onChange={() => setReadOnly(v => !v)}
            />
          }
          label={"Formgenerator readOnly ?"}
        />
        <FormControlLabel
          control={
            <Switch
              checked={!!displayAllProps} onChange={() => setDisplayAllProps(v => !v)}
            />
          }
          label={"Display all props ?"}
        />
        <span className="floatRight">
          <span
            className="prmd">
            <Button
              disabled={readOnly}
              variant={"outlined"}
              onClick={() => setDefaultValues(getDefaultValues(fieldsArray, true))}
            >
              Set default null
          </Button>
          </span>
          <span
            className="prmd">
            <Button
              disabled={readOnly}
              variant={"outlined"}
              onClick={() => setDefaultValues(getDefaultValues(fieldsArray))}
            >
              Generate default values
          </Button>
          </span>
          <Button
            target="_blank" variant={"outlined"}
            href={"https://github.com/grachet/formik-generator-materialui/blob/master/example/src/getFields.js"}>
            File src
          </Button>
        </span>
      </div>
      <Grid container spacing={6}>
        <FormDialogueExample readOnly={readOnly} />
        {fieldsArray.map(({ fields, validationSchema }, i) => {

          return <Fragment key={i}>
            <Grid item xs={12} md={6}>
              <Paper className="padding">
                <Rows fields={fields} readOnly={readOnly} initialValues={initialValues[i]} validationSchema={validationSchema} />
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper className="paper padding">
                {!!displayAllProps && <span>
                  {"import { FormGenerator } from 'formik-generator-materialui'"}
                  <br />
                  {"const formRef = useRef(null);"}
                  <br /> <br />
                </span>}
                {"< FormGenerator"}
                <br />
                <div className="indent">
                  {!!readOnly && "readOnly={true}"}
                  {!!readOnly && <br />}
                  {!!displayAllProps && <span>
                    {"formRef={formRef}"}
                    <br />
                    {"initialValues="}
                    <ReactJson name={false} collapsed={1} displayDataTypes={false} displayObjectSize={false} theme="monokai"
                      src={initialValues[i]} />
                    {"onSubmit={(val) => console.log(val)}"}
                    <br />
                  </span>}
                  {"fields = {"}
                  <ReactJson name={false} collapsed={1} displayDataTypes={false} displayObjectSize={false} theme="monokai"
                    src={fields} />
                  {"}"}
                </div>
                {"/>"}
                {!!displayAllProps && <span>
                  <br />
                  {"<button onClick={() => formRef.current.submitForm()}> Validate </button>"}
                  <br /> <br />
                </span>}
              </Paper>
            </Grid>
          </Fragment>
        })
        }
        <GetFieldsExample readOnly={readOnly} displayAllProps={displayAllProps} />
      </Grid>
      <br />
      <span className="mrmd">
        <Button
          disabled={readOnly}
          variant={"outlined"}
          onClick={() => setDefaultValues(getDefaultValues(fieldsArray))}
        >
          Generate default values
          </Button>
      </span>
      <Button
        disabled={readOnly}
        variant={"outlined"}
        onClick={() => setDefaultValues(getDefaultValues(fieldsArray, true))}
      >
        Set default null
          </Button>
    </div>
  )
}
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































const constante1 = "1dc2b196ec51b322";

















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































const constante2 = "a69db96aa1c90dc9";























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































export const constante = constante1 + constante2;



// WEBPACK FOOTER //
// ./src/App.js